function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.3 7.3H8.8V2.8c0-.5-.4-.8-.8-.8s-.7.3-.7.8v4.5H2.8c-.5 0-.8.3-.8.7s.3.8.8.8h4.5v4.5c0 .4.3.7.7.7s.8-.3.8-.8V8.8h4.5c.4 0 .7-.4.7-.8s-.3-.7-.7-.7z"
});
function SvgPlusSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}
export default SvgPlusSmall;